import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import { HiOutlineDownload, HiOutlineCog } from 'react-icons/hi';

const SegmentComparision = () => {
  const [comparisonMetric, setComparisonMetric] = useState('Mobile vs Desktop'); // State for segment comparison
  const comparisonChartRef = useRef(null);

  // Metric Labels (these will be constant as they represent different performance metrics)
  const metricsLabels = ['Engagement', 'Conversion', 'Retention', 'Page Views', 'Session Duration'];

  // Data for segment comparisons (Mobile vs Desktop, New vs Returning, Organic vs Paid)
  const comparisonData = {
    'Mobile vs Desktop': {
      labels: metricsLabels,
      data: [
        [80, 50, 65, 90, 70],  // Mobile
        [60, 90, 75, 60, 85],  // Desktop
      ],
      segmentLabels: ['Mobile', 'Desktop'],  // These are the segment labels
      backgroundColor: [
        'rgba(59, 130, 246, 0.8)', // Mobile color
        'rgba(139, 92, 246, 0.8)', // Desktop color
      ],
    },
    'New vs Returning': {
      labels: metricsLabels,
      data: [
        [75, 65, 55, 85, 75], // New Visitors
        [60, 85, 80, 80, 90], // Returning Visitors
      ],
      segmentLabels: ['New Visitors', 'Returning Visitors'], // Correct labels
      backgroundColor: [
        'rgba(59, 130, 246, 0.8)', // New Visitors
        'rgba(139, 92, 246, 0.8)', // Returning Visitors
      ],
    },
    'Organic vs Paid': {
      labels: metricsLabels,
      data: [
        [85, 70, 60, 92, 78], // Organic
        [70, 60, 65, 75, 80], // Paid
      ],
      segmentLabels: ['Organic', 'Paid'], // Correct labels for this case
      backgroundColor: [
        'rgba(16, 185, 129, 0.8)', // Organic
        'rgba(59, 130, 246, 0.8)', // Paid
      ],
    },
  };

  useEffect(() => {
    let comparisonChartInstance;

    if (comparisonChartRef.current) {
      comparisonChartInstance = new Chart(comparisonChartRef.current, {
        type: 'bar', // Bar chart, you can switch to 'line' for line chart
        data: {
          labels: comparisonData[comparisonMetric].labels, // Always keep the metrics labels as the x-axis
          datasets: [
            {
              label: comparisonData[comparisonMetric].segmentLabels[0], // Mobile / New Visitors / Organic
              data: comparisonData[comparisonMetric].data[0], // Data for the first segment
              backgroundColor: comparisonData[comparisonMetric].backgroundColor[0],
              borderWidth: 1,
              borderRadius: 4,
            },
            {
              label: comparisonData[comparisonMetric].segmentLabels[1], // Desktop / Returning Visitors / Paid
              data: comparisonData[comparisonMetric].data[1], // Data for the second segment
              backgroundColor: comparisonData[comparisonMetric].backgroundColor[1],
              borderWidth: 1,
              borderRadius: 4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'top' },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.dataset.label || '';
                  const value = context.raw || '';
                  return `${label}: ${value}%`; // Show the percentage when hovering over the bars
                },
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: { display: true, color: 'rgba(0, 0, 0, 0.05)' },
            },
            x: {
              grid: { display: false },
            },
          },
        },
      });
    }

    return () => {
      comparisonChartInstance?.destroy();
    };
  }, [comparisonMetric]); // Re-run effect when comparisonMetric changes

  return (
<div className="bg-white rounded-lg shadow-md p-4 transition-all duration-300 hover:shadow-lg">

      <div className="flex justify-between items-center mb-6">

        <div className="flex items-center space-x-4">
            <div className="text-lg font-semibold text-gray-700">Segment Comparison:</div>
            <select
              value={comparisonMetric}
              onChange={(e) => setComparisonMetric(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 bg-white text-sm"
            >
              <option>Mobile vs Desktop</option>
              <option>New vs Returning</option>
              <option>Organic vs Paid</option>
            </select>
          </div>
        </div>

        {/* Comparison Chart */}
        <div>
            <canvas ref={comparisonChartRef} className="h-64"></canvas>
          </div>


      </div>

  );
};

export default SegmentComparision;